module.exports = __webpack_public_path__ + "img/viaDirectFlight.a78cb5a5.svg";